import React from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';
import UnlockWinningsicon from './Images/mdi_chevron-up.svg';
export const UnlockWinnings: React.FC = () => {
  return (
    <div className={clsx(styles.container,"fontSizeSm14 fontWeightBold")}>
      <img
        loading="lazy"
        src={UnlockWinningsicon}
        alt=''
        className={styles.icon}
      />
      <p className={styles.winningsmessage}>
        Unlock maximum winnings by playing all your entries
      </p>
      <img
        loading="lazy"
        src={UnlockWinningsicon}
        alt=''
        className={styles.icon}
      />
    </div>
  );
};